import { ConfigService } from './../settings/config.service';
import { SingleDropboxData } from './../shared/single-dropbox/single-dropbox.component';
import { StationSource } from './../core/models/station-source';
import { Location } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, convertToParamMap, ParamMap, Params, Router } from '@angular/router';
import { IhmLoadingIndicatorService } from '@ihm-software/ihm-ui-common-angular-10';
import * as moment from 'moment-timezone';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { Observable } from 'rxjs';
import { delay, map } from 'rxjs/operators';

import { RemoteApiService, Station } from '../core';
import { ProfileModelService } from '../profile/profile-model.service';
import { SearchFiltersService } from '../search-filters/search-filters.service';
import { MultiDropboxComponent } from '../shared';
import { Email } from '../shared/model/email.interface';
import { StationUtilsService } from '../shared/utils/station-utils.service';
import { TimezoneUtilsService } from '../shared/utils/timezone-utils.service';
import { environment } from './../../environments/environment';
import { MyErrorStateMatcher } from './../shared/model/error-state-matcher';
import { Option } from './../shared/model/option';
import { TimezoneEnum } from './../shared/model/time-zone.enum';
import { DownloadService } from './download.service';
import { AudioFormatEnum } from './model/audio-format-enum';
import { DownloadMethodEnum } from './model/download-method-enum';
import { DownloadMoment } from './model/download-moment.interface';


declare function require(name: string);
const confirmDatePlugin = require('flatpickr/dist/plugins/confirmDate/confirmDate');
declare var dataLayer;


const getTomorrow = () => {
  const today = new Date();
  const tomorrow = new Date(today);

  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow;
};


@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.scss'],
  providers: [ConfigService]
})
export class DownloadsComponent implements OnInit, AfterViewInit {
  
  downloadOptions = [
    { name: 'Audio', value: 'AUDIO' }
  ];
  downloadOption = this.downloadOptions[0];

  formatOptions: Option<AudioFormatEnum>[] = AudioFormatEnum.getOptions();
  formatOption = this.formatOptions[0];

  methodOptions: Option<DownloadMethodEnum>[] = DownloadMethodEnum.getOptions();
  methodOption = this.methodOptions[0];

  stationSources: SingleDropboxData[] = [];
  stationSourceSelected: SingleDropboxData;
  isStationSourcesDropboxDisable = true;
  timezoneTypeOptions: Option<TimezoneEnum>[] = TimezoneEnum.getOptions();
  selectedTimezoneTypeOption: Option<TimezoneEnum>;
  downloadListTimezoneType: TimezoneEnum;

  @ViewChild('stationMulti', { static: true })
  stationMulti: MultiDropboxComponent;

  @ViewChild('stationSourceMulti', { static: true })
  stationSourceMulti: MultiDropboxComponent;

  stations: any;
  selectedStation: SingleDropboxData;
  origStationsList: Station[] = [];

  @ViewChild('sliderInputBox', { static: true })
  public sliderInputBox: ElementRef;
  @ViewChild('emailBox', { static: true }) public emailBox: ElementRef;
  @ViewChild('matLabel', { static: true }) public matLabel: ElementRef;

  // slider
  sliderValue = 5;
  sliderMax = environment.maxDownloadTime;

  dateTimeCtrl = new FormControl(null);  
  // For single-dropbox
  disableStationsDropBox = true;
  
  timeFormatForMomentJs = 'MM/DD/Y h:mm:ss a'; // h-> hours, m-> minutes, s-> seconds, a-> am/pm 
  @ViewChild('startPicker') pickerStart;
  //audioBucketRetentionPolicy: Date = moment().subtract(this.s3Lifecycle, 'days').toDate();
  startOptions: FlatpickrOptions = {
    mode: 'single',
    dateFormat: 'm/d/Y G:i:S K',
    maxDate: getTomorrow(),
    enableTime: true,
    enableSeconds: true,
    minuteIncrement: 1,
    plugins: [new confirmDatePlugin({ showAlways: true })],
  };
  
  // For Email
  emailCtrl = new FormControl(null, [
    Validators.required,
    Validators.pattern(
      '^[A-Za-z0-9._%+-]+@[a-zA-Z0-9-]+\\.[A-Za-z]{1,3}[.]?[A-Za-z]{1,}$'
    )
  ]);
  matcher = new MyErrorStateMatcher();

  filteredEmails: Observable<Email[]>;

  // Confirmation page
  isConfirmed = false;
  displayedStationName: string;
  displayedDateTime: string;
  displayAudioFormatName: string;
  displayStationSourceName: string;
  displayedTimeZone : string;
  isSuccess = false;

  // query params
  stationIdFromQueryParams: string;
  stationObjFromQueryParam: any;
  paramsMap: ParamMap;
  currentUserEmail: any;

  s3Lifecycle;

  displayedColumns = [
    'stationName',
    'stationSource',
    'startDate',
    'endDate',
    'durationInSeconds',
    'downloadLink'
  ];

  downloadList: DownloadMoment[] = [];

  constructor(
    private stationUtilsService: StationUtilsService,
    private profileModelService: ProfileModelService,
    private cdr: ChangeDetectorRef,
    private location: Location,
    private titleService: Title,
    private route: ActivatedRoute,
    private router: Router,
    private searchFiltersService: SearchFiltersService,
    private remoteApi: RemoteApiService,
    private downloadService: DownloadService,
    private timezoneUtilsService: TimezoneUtilsService,
    private loaderService: IhmLoadingIndicatorService,
    private configService: ConfigService
  ) {    
    this.titleService.setTitle('SIA (Search, Index, Archive) - Downloads');

    this.route.queryParams.subscribe((params: Params) => {
      const paramMap = convertToParamMap(params);
      this.location.replaceState(
        this.router.createUrlTree(['downloads']).toString()
      );
      this.paramsMap = paramMap;
      this.stationIdFromQueryParams = paramMap.get('stationId');
      this.cdr.markForCheck();
    });
    
    
  
  }

  ngOnInit() {
    this.isConfirmed = false;
    this.currentUserEmail = this.profileModelService.getProfile().token;
    this.selectedTimezoneTypeOption = this.timezoneTypeOptions.find(opt => opt.value === this.profileModelService.getDefaultTimezoneType());
    this.downloadListTimezoneType = this.selectedTimezoneTypeOption.value;
    this.loadStations();
  }

  back() {
    this.isConfirmed = !this.isConfirmed;
    this.clear();
  }

  ngAfterViewInit() {
    this.optionSelected();
    this.cdr.markForCheck();
    this.emailCtrl.setValue(this.currentUserEmail);
    this.cdr.markForCheck();

    this.configService.findLifecycle()
      .subscribe((config) => {
        this.s3Lifecycle = config.value;
        this.pickerStart.flatpickr['config'].minDate = moment().subtract(config.value, 'days').toDate();
      });
  }

    
  public loadStations() {
    this.searchFiltersService.loadAllStations().pipe(delay(1)).subscribe((stations) => {
      this.disableStationsDropBox = false;
      this.origStationsList = stations;

      if (this.origStationsList.length) {
        this.loadDownloadLinks();
      }

      this.stationMulti.setList(
        stations.map((station) => {
          if (this.stationIdFromQueryParams === station.id) {
            this.stationObjFromQueryParam = {
              id: station.id,
              name: station.name,
              model: station
            };
            this.downloadOption = this.downloadOptions[0];
            this.formatOption = this.formatOptions[0];

            this.optionSelected();
            const selectedTime = moment(
              this.paramsMap.get('segmentStartTime').split('[')[0]
            );
            selectedTime.add(
              Math.floor(+this.paramsMap.get('currentTime')),
              'seconds'
            );
            this.dateTimeCtrl.setValue([selectedTime.toDate()]);
            this.pickerStart.flatpickr['setDate'](
              selectedTime.format('MM/DD/YYYY hh:mm:ss A')
            );
            this.cdr.markForCheck();
          }
          return {
            id: station.id,
            name: station.name,
            model: station
          };
        }));
      if (this.stationObjFromQueryParam) {
        const mergedStation = this.stationMulti.getAllItems().find(station => station.id.some(id => id === this.stationObjFromQueryParam.id)).mergedStation;
        this.selectedStation = this.stationUtilsService.toSingleDropboxData(mergedStation.model.find(station => station.id === this.stationObjFromQueryParam.id));

        // Trigger events when a station is selected
        this.selectStation(this.selectedStation);
        this.stations = this.selectedStation;
      }
    });
  }

  optionSelected() {
    // slider & input box
    this.sliderInputBox.nativeElement.disabled = false;

    // picker
    this.pickerStart.flatpickr['input'].disabled = false;
    this.pickerStart.flatpickr['element'].style.borderBottom = '1px solid grey';
    this.pickerStart.flatpickr['input'].placeholder = '';
    this.matLabel.nativeElement.style.display = '';
  }
  submit() {
    this.displayedDateTime = moment(this.dateTimeCtrl.value[0], this.timeFormatForMomentJs).format(this.timeFormatForMomentJs).toUpperCase();
    this.displayedTimeZone = this.selectedTimezoneTypeOption.value == TimezoneEnum.STATION ? this.selectedStation.mergedStation.timeZone : moment.tz.guess();
    this.displayedStationName = this.stations['name'];
    
    this.displayStationSourceName = this.stationSourceSelected.name;

    this.displayAudioFormatName =
      this.formatOption.name === 'Audio MP3'
        ? 'a <b>MP3 Audio</b>'
        : 'an <b>AAC Audio</b>';
    
    
    
    const startDateTimeStr = this.getDateISOString(this.dateTimeCtrl.value[0]);
    const endDate = moment(this.dateTimeCtrl.value[0]).add(this.sliderValue, 'minutes').toDate();
    const endDateTimeStr = this.getDateISOString(endDate);
    // Change these properties according to API spec
    
    this.remoteApi
      .postDownload('/download', {
        stationId: this.getSelectedStationId(),
        startDateTime: startDateTimeStr,
        endDateTime: endDateTimeStr,
        userId: this.emailCtrl.value,
        downloadType: this.downloadOption.value,
        format: this.formatOption.value,
        deliveryMethodType: this.methodOption.value
      })
      .toPromise()
      .then((download) => {
        this.isSuccess = true;
        this.isConfirmed = true;
      })
      .catch((e) => {
        this.isConfirmed = true;
        this.isSuccess = false;
        console.error('Error occurred:', e);
      });
    try {
      dataLayer.push({
        event: 'click-download-clip',
        operation: 'download',
        'User-Id': this.currentUserEmail,
        option: this.displayAudioFormatName
      });
    } catch (e) { }
  }

  clear() {
    this.formatOption = this.formatOptions[0];
    this.methodOption = this.methodOptions[0];
    this.stationSourceSelected = null;
    this.stations = null;
    this.selectedStation = null;
    this.isStationSourcesDropboxDisable = true;
    this.dateTimeCtrl.setValue(null);
    this.pickerStart.flatpickr['clear']();
    this.pickerStart.flatpickr['input'].placeholder = 'Start Date & Time';
    this.emailCtrl.setValue(this.currentUserEmail);
    this.sliderValue = 5;
  }

  getDownloads() {
    this.loadDownloadLinks();
  }

  backToDownload() {
    this.isConfirmed = false;
    this.loadDownloadLinks();
  }

  optionDownload() {
    this.emailCtrl.setValue(this.currentUserEmail);
  }

  public selectStation(station: SingleDropboxData) {
    this.selectedStation = station;
    this.setStationSources(station.mergedStation.stationSources);
    this.pickerStart.flatpickr.set({
      maxDate: this.getDateonSelectedTz(new Date(),this.selectedTimezoneTypeOption.value,this.selectedStation.model[0].timeZone)
   });
  }

  public selectStationSource(source: SingleDropboxData) {
    this.stationSourceSelected = source;

  }

  public selectTimezone(timezone: Option<TimezoneEnum>){
    this.selectedTimezoneTypeOption = timezone;
    this.pickerStart.flatpickr.set({
       maxDate: this.getDateonSelectedTz(new Date(),this.selectedTimezoneTypeOption.value,this.selectedStation?.model?.[0].timeZone)
    });
  }  
 

  setStationSources(stationSources: StationSource[]) {
    if (stationSources) {
      this.stationSources = stationSources.map(source => {
        return {
          id: source.id,
          name: source.name,
          model: source
        };
      });
    }

    this.stationSourceMulti.setList(this.stationSources);

    if (this.stationSources && this.stationSources.length > 1) {
      this.isStationSourcesDropboxDisable = false;
    } else {
      this.isStationSourcesDropboxDisable = true;
    }

    const defaultStationSource = this.profileModelService.getDefaultStationSource();

    this.stationSourceSelected = null;

    if (this.stationSources.length === 1) {
      this.stationSourceSelected = this.stationSources[0];
    }

    if (defaultStationSource) {
      if (this.stationSources.find(source => source.id === defaultStationSource.id)) {
        this.stationSourceSelected = {
          id: defaultStationSource.id,
          model: defaultStationSource,
          name: defaultStationSource.name
        };
      }
    }
  }

  changeDownloadListTimezone(dateMoment: moment.Moment, stationName: string) {
    if (!dateMoment || !stationName) {
      return '';
    }
    switch (this.downloadListTimezoneType) {
      case TimezoneEnum.STATION:
        const stationTimezone = this.getStationTimezone(stationName);
        if (stationTimezone) {
          // return dateMoment.clone().tz(this.getStationTimezone(stationName)).format('h:mm:ss A');
          return dateMoment.clone().tz(this.getStationTimezone(stationName)).format('MMM Do, h:mm:ss A');
        }
        return '';
      case TimezoneEnum.USER:
        // return dateMoment.clone().tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('h:mm:ss A');
        return dateMoment.clone().tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('MMM Do, h:mm:ss A');
    }
  }

  updateDownloadListTimezone(useDefaultTimezoneChecked: boolean) {
    const userDefaultTimezone = this.profileModelService.getDefaultTimezoneType();
    // Use the default user timezone
    if (useDefaultTimezoneChecked) {
      this.downloadListTimezoneType = userDefaultTimezone;
    } else {
      // Use the timezone different from default user timezone
      this.downloadListTimezoneType = userDefaultTimezone === TimezoneEnum.STATION ?
        TimezoneEnum.USER : TimezoneEnum.STATION;
    }
    // To cause change detection and update the start and end time in the download table list
    this.downloadList.map(download => {
      download.startDateString = this.changeDownloadListTimezone(download.startDate, download.stationName);
      download.endDateString = this.changeDownloadListTimezone(download.endDate, download.stationName);
    });
  }

  timezoneTypeToString(tzType: TimezoneEnum): string {
    switch (tzType) {
      case TimezoneEnum.STATION:
        return 'Station Timezone';
      case TimezoneEnum.USER:
        return 'My Timezone';
      default:
        return '';
    }
  }

  downloadFile(url: string) {
    this.loaderService.toggle(true);
    this.downloadService.downloadFile(url).subscribe(
      blobS3 => {
        this.loaderService.toggle(false);
        const filename = url.substring(url.lastIndexOf('/') + 1);
        const blob = new Blob([blobS3], { type: blobS3.type });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      });
  }

  private getStationTimezone(stationName: string) {
    return this.origStationsList.find(station => station.name === stationName)?.timeZone;
  }

  private getDateISOString(date: Date): string {
    switch (this.selectedTimezoneTypeOption.value) {
      case TimezoneEnum.STATION:
        // Because both (media monitors and sound+) have same timezone, we can just get the first one
        // in model array
        return this.timezoneUtilsService.getISOStringTimezone(date, this.selectedStation.model[0].timeZone);
      case TimezoneEnum.USER:
        return date.toISOString();
    }
  }

  private getDateonSelectedTz(date: Date,timezone:string,loadedTz:string): string  {
    switch (timezone) {
      case TimezoneEnum.STATION:
        // Because both (media monitors and sound+) have same timezone, we can just get the first one
        // in model array
        let timezonedate = new Date(date.toLocaleString("en-US", { timeZone: loadedTz }))
        let totalMilliSeconds = timezonedate.getTime( );
        let millisecondsToSubtract = 5 * 60 * 1000;
        let newDate = new Date ( totalMilliSeconds - millisecondsToSubtract )
        return  newDate.toISOString();
      case TimezoneEnum.USER:
        return date.toISOString();
    }  
  }

  private getSelectedStationId(): string {
    return this.selectedStation.mergedStation.mapStationSources.get(this.stationSourceSelected.id);
  }

  private loadDownloadLinks() {
    this.loaderService.toggle(true);
    this.downloadList = [];

    this.downloadService
      .getDownloads(this.currentUserEmail)
      .pipe(map(response => {
        return response.map((download) => {
          
          const startDate = moment.utc(download.startDate);
          const endDate = moment.utc(download.endDate);
          const startDateString = this.changeDownloadListTimezone(startDate, download.stationName);
          const endDateString = this.changeDownloadListTimezone(endDate, download.stationName);
          const stationTimezone = this.getStationTimezone(download.stationName);
          return {
            ...download,
            startDate,
            endDate,
            startDateString,
            endDateString,
          };
        });
      }))
      .subscribe(response => {
        this.downloadList = response;
      },
        (error) => {
          console.error('loadDownloadLinks', error);
          this.loaderService.toggle(false);
        },
        () => this.loaderService.toggle(false));
  }

  get disableSubmitButton() {
    if (
      this.formatOption &&
      this.stations &&
      this.stations['name'] &&
      this.stationSourceSelected &&
      this.isDateTimeFilled() &&
      this.sliderValue &&
      this.sliderValue > 0 &&
      this.sliderValue <= this.sliderMax &&
      (this.methodOption.value === DownloadMethodEnum.EMAIL && this.emailCtrl.valid ||
        this.methodOption.value === DownloadMethodEnum.DOWNLOAD)
    ) {
      return false;
    }
    return true;
  }

  private isDateTimeFilled() {
    // Should be an array and to have at least one element and its first element should be a Date
    return Array.isArray(this.dateTimeCtrl?.value)
      && this.dateTimeCtrl?.value?.length > 0
      && this.dateTimeCtrl?.value[0] instanceof Date;
  }

  get DownloadMethodEnum() {
    return DownloadMethodEnum;
  }

  get TimezoneType() {
    return TimezoneEnum;
  }

  daysTooltip(){
    if(this.s3Lifecycle > 0)
      return this.s3Lifecycle+" days of past audio is available.";
    return "Loading...";
  }
}
